import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { EmailManagementDashboard } from '../../../features/email-management'

export const EmailManagementPage = () => {
  return (
    <Routes>
      <Route path="/" element={<EmailManagementDashboard />} />
    </Routes>
  )
}
